import * as yup from "yup";
import { checkIfUsernameExists } from "./register.actions";

export const createRegistrationFormSchema = ({ dispatch, validationRules }) => {
	return yup
		.object({
			organisationNumber: yup
				.string()
				.min(2, "komid.register.validation.required")
				.max(100, "komid.register.validation.required")
				.required("komid.register.validation.required"),
			name: yup
				.string()
				.min(2, "komid.register.validation.required")
				.max(40, "komid.register.validation.required")
				.test(
					"two-words",
					"komid.register.validation.required",
					(value) => value.trim().indexOf(" ") !== -1,
				)
				.required(),
			businessName: yup
				.string()
				.min(2, "komid.register.validation.required")
				.max(40, "komid.register.validation.length.max")
				.required(),
			companyAddress: yup
				.string()
				.min(2, "komid.register.validation.required")
				.max(60, "komid.register.validation.required")
				.required(),
			postcode: yup
				.string()
				.min(2, "komid.register.validation.required")
				.max(40, "komid.register.validation.length.max")
				.required(),
			city: yup
				.string()
				.min(2, "komid.register.validation.required")
				.max(40, "komid.register.validation.length.max")
				.required(),
			phone: yup
				.string()
				.min(2, "komid.register.validation.required")
				.max(40, "komid.register.validation.length.max")
				.test("valid-phone", "komid.register.validation.required", (value) =>
					new RegExp(validationRules.mobilePhone).test(value),
				)
				.required(),
			email: yup
				.string()
				.test("valid-email", "komid.register.validation.required", (value) =>
					new RegExp(validationRules.email).test(value),
				)
				.test(
					"email-exists",
					"komid.register.validation.username.exists",
					async (value) => {
						if (
							new RegExp(validationRules.email).test(value) &&
							validationRules.notSameAsUsername(value)
						) {
							const response = await dispatch(
								checkIfUsernameExists({ username: value, form: "b2b" }),
							).unwrap();

							if (response.result.isSuccess && response.result.userExists) {
								return null;
							}
							return true;
						}
						return true;
					},
				)
				.min(2, "komid.register.validation.required")
				.max(70, "komid.register.validation.length.max")
				.required(),
			invoiceEmail: yup
				.string()
				.test("valid-email", "komid.register.validation.required", (value) =>
					new RegExp(validationRules.email).test(value),
				)
				.min(2, "komid.register.validation.required")
				.max(70, "komid.register.validation.length.max")
				.required(),
			password: yup
				.string()
				.min(8, "komid.register.validation.required")
				.max(70, "komid.register.validation.length.max")
				.required(),
			acceptSalesConditions: yup
				.bool()
				.oneOf([true], "komid.register.validation.required")
				.required(),
			acceptOffersInformations: yup
				.bool()
				.oneOf([true, false], "komid.register.validation.required"),
			acceptMarketingConsents: yup
				.bool()
				.test(
					"other-checked",
					"komid.register.business.consents.accept.error.message",
					(value, context) => {
						if (
							value &&
							!validationRules.enableClubAgreementConsent &&
							!context.parent.accept3rdPartyMarketingConsents
						) {
							return null;
						}
						return true;
					},
				),
			accept3rdPartyMarketingConsents: yup
				.bool()
				.test(
					"other-checked",
					"komid.register.business.consents.accept.error.message",
					(value, context) => {
						if (
							value &&
							!validationRules.enableClubAgreementConsent &&
							!context.parent.acceptMarketingConsents
						) {
							return null;
						}
						return true;
					},
				),
			acceptSmsNotifications: yup
				.bool()
				.test(
					"other-checked",
					"komid.register.business.consents.accept.sms.error.message",
					(value, context) => {
						const oldConsentsEmpty =
							!validationRules.enableClubAgreementConsent &&
							!(
								context.parent.acceptMarketingConsents ||
								context.parent.accept3rdPartyMarketingConsents
							);
						const newConsentsEmpty =
							validationRules.enableClubAgreementConsent &&
							!context.parent.acceptClubAgreementConsents;
						if (value && (oldConsentsEmpty || newConsentsEmpty)) {
							return null;
						}
						return true;
					},
				),
			acceptClubAgreementConsents: yup
				.bool()
				.oneOf([true, false], "komid.register.validation.required"),
		})
		.required();
};
